__turbopack_context__.v({
  "icon": "OwnerViewToggle-module__QpPN_W__icon",
  "option": "OwnerViewToggle-module__QpPN_W__option",
  "optionActive": "OwnerViewToggle-module__QpPN_W__optionActive",
  "optionLabel": "OwnerViewToggle-module__QpPN_W__optionLabel",
  "thumb": "OwnerViewToggle-module__QpPN_W__thumb",
  "thumbPublic": "OwnerViewToggle-module__QpPN_W__thumbPublic",
  "toggle": "OwnerViewToggle-module__QpPN_W__toggle",
});
